import { render, staticRenderFns } from "./UpNext.vue?vue&type=template&id=66cd008b&scoped=true&"
import script from "./UpNext.vue?vue&type=script&lang=js&"
export * from "./UpNext.vue?vue&type=script&lang=js&"
import style0 from "./UpNext.vue?vue&type=style&index=0&id=66cd008b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cd008b",
  null
  
)

export default component.exports